import React, { useEffect } from 'react';
import useLocale from '@/utils/useLocale';
import { GlobalContext } from '@/context';
import { useContext } from 'react';
import defaultLocale from '@/locale';

interface PageTitleProps {
  title?: string;
  titleKey?: string;
}

function PageTitle(props: PageTitleProps) {
  const { title, titleKey } = props;
  const { lang } = useContext(GlobalContext) || { lang: 'zh-CN' };
  const t = useLocale();

  const getPageTitle = () => {
    let pageTitle = '';
    if (title) {
      pageTitle = title;
    } else if (titleKey) {
      // 直接检查本地化对象中是否有对应键
      if (t[titleKey]) {
        pageTitle = t[titleKey];
      } else {
        // 尝试处理带点号的键，例如 menu.contentSource.policy
        const localeObj =
          lang === 'zh-CN' ? defaultLocale['zh-CN'] : defaultLocale['en-US'];
        if (localeObj && localeObj[titleKey]) {
          pageTitle = localeObj[titleKey];
        } else {
          // 如果没有找到翻译，使用键名的最后一部分作为标题
          const keys = titleKey.split('.');
          pageTitle = keys[keys.length - 1];
        }
      }
    }

    if (!pageTitle) {
      // 默认标题已经包含了网站名称，不需要再添加后缀
      return lang === 'zh-CN' ? '速问平台' : 'MedBox Data Platform';
    }

    // 添加网站名称后缀
    const suffix = lang === 'zh-CN' ? ' - 速问' : ' - MedBox Data';
    return pageTitle + suffix;
  };

  // 使用useEffect钩子来更新文档标题
  useEffect(() => {
    document.title = getPageTitle();
    // 在组件卸载时恢复默认标题
    return () => {
      document.title = lang === 'zh-CN' ? '速问平台' : 'MedBox Data Platform';
    };
  }, [title, titleKey, lang]);

  // 不再返回Helmet组件
  return null;
}

export default PageTitle;
